var $393254ebcb66c9f5$exports = {};
$393254ebcb66c9f5$exports = {
    "Empty": `\u{41F}\u{443}\u{441}\u{442}\u{43E}`
};


export {$393254ebcb66c9f5$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
